// src/components/strumenti/BandaReteTVCC.js
import React, { useState } from "react";
import { RefreshCw, Plus, Trash2 } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"8px 10px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:13, fontFamily:"'Inter',sans-serif", outline:"none" };

export default function BandaReteTVCC() {
  const [gruppi, setGruppi] = useState([{ id:1, canali:"", bitrate:"" }]);

  const totaleMbps = gruppi.reduce((s,g) => {
    const n = parseFloat(g.canali)||0;
    const kb = leggiNumero(g.bitrate)||0;
    return s + (n*kb)/1000;
  }, 0);

  const aggiorna = (id, campo, val) => setGruppi(gg => gg.map(g => g.id===id ? {...g,[campo]:val} : g));
  const aggiungi = () => setGruppi(gg => [...gg, { id:Date.now(), canali:"", bitrate:"" }]);
  const rimuovi = id => setGruppi(gg => gg.length>1 ? gg.filter(g=>g.id!==id) : gg);

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 24px", gap:6, marginBottom:6, fontSize:10, fontWeight:700, color:"#9ca3af" }}>
        <div>N° canali</div><div>Bitrate cad. (kbps)</div><div></div>
      </div>
      {gruppi.map(g => (
        <div key={g.id} style={{ display:"grid", gridTemplateColumns:"1fr 1fr 24px", gap:6, marginBottom:6, alignItems:"center" }}>
          <input value={g.canali} onChange={e=>aggiorna(g.id,"canali",e.target.value)} style={inp} placeholder="Es. 8"/>
          <input value={g.bitrate} onChange={e=>aggiorna(g.id,"bitrate",e.target.value)} style={inp} placeholder="Es. 4096"/>
          <button onClick={()=>rimuovi(g.id)} style={{ background:"none", border:"none", color:"#c4b5fd", cursor:"pointer" }}><Trash2 size={14}/></button>
        </div>
      ))}
      <button onClick={aggiungi} style={{ display:"flex", alignItems:"center", gap:4, fontSize:12, color:"#6d28d9", background:"none", border:"none", cursor:"pointer", marginBottom:16, fontWeight:600 }}>
        <Plus size={13}/> Aggiungi gruppo (es. telecamere diverse)
      </button>

      <div style={{ background:"#f5f3ff", border:"1px solid #ddd6fe", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Banda totale necessaria</div>
        <div style={{ fontSize:22, fontWeight:800, color:"#6d28d9" }}>
          {totaleMbps.toLocaleString("it-IT",{maximumFractionDigits:1})}
          <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>Mbps</span>
        </div>
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Utile per dimensionare la rete/switch e la banda di upload per la visione remota.
      </div>

      <button onClick={()=>setGruppi([{ id:Date.now(), canali:"", bitrate:"" }])}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
